import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div<{ customPadding?: string }>`
    display: block;
    padding: ${props => `${props.theme.spacing.xxxSmall} 0`};
    color: ${props => props.theme.colors[props.theme.colorMode].text_High_Emphasis};
    padding-bottom: 1px;
`;

export const TruncatedText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    outline: 0;
    white-space: nowrap;
    flex-shrink: 1;
`;

export const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    outline: none;
    overflow: hidden;
`;

export const InlineBalanceContainer = styled.div`
    display: flex;
`;

export const BalanceText = styled(Text)`
    :before {
        content: "\u20B9";
        margin-left: ${({ theme }) => theme.spacing.xxSmall};
    }
`;

export const Name = styled(Text)`
    display: flex;
    flex-grow: 0;
    flex-shrink: 1;
    overflow: hidden;
`;
